var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Routes = function Routes(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M15 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM8.5 6a2.5 2.5 0 1 0 0 5h8a4.5 4.5 0 1 1 0 9H12a1 1 0 1 1 0-2h4.5a2.5 2.5 0 0 0 0-5h-8a4.5 4.5 0 1 1 0-9H12a1 1 0 1 1 0 2H8.5ZM3 19a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Routes;